import React from 'react';
import { motion } from 'framer-motion';
import Hero from '../components/sections/Hero';
import Products from '../components/sections/Products';
import SEO from '../components/common/SEO';
import { Leaf, Award, Globe, Shield } from 'lucide-react';

const RevealSection = ({ children, id }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      id={id}
    >
      {children}
    </motion.div>
  );
};

const Home = ({ onShowDetail }) => {
  return (
    <main>
      <SEO 
        title="Home" 
        description="AgniThrust Private Ltd. - Leading the way in sustainable energy. We produce high-quality biomass pellets and bio coal for a greener tomorrow. Explore our industrial solutions."
      />
      <Hero />
      
      <RevealSection id="about_home">
         <section className="py-24 px-6 md:px-12 max-w-7xl mx-auto border-t border-white/5">
            <div className="grid md:grid-cols-2 gap-24 items-center">
               <div className="relative text-left">
                  <div className="absolute inset-0 bg-primary/20 blur-[100px] -z-10 rounded-full"></div>
                  <div className="glass p-1 rounded-[60px] overflow-hidden border border-white/10 group aspect-[4/5] relative">
                     <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent z-10"></div>
                     {/* Placeholder for About Image */}
                     <div className="w-full h-full bg-[#151515] flex items-center justify-center p-12 text-center group-hover:scale-110 transition-transform duration-700">
                        <img src="/images/pellets.png" alt="Bio Mass" className="absolute inset-0 w-full h-full object-cover opacity-60 grayscale group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-700" />
                     </div>
                     <div className="absolute inset-x-12 bottom-12 z-20">
                        <p className="text-primary font-bold tracking-widest uppercase text-sm mb-4">Our Mission</p>
                        <h3 className="text-2xl font-extrabold syne leading-tight">Clean Energy for a Brighter Future.</h3>
                     </div>
                  </div>
               </div>
               <div className="space-y-12 text-left">
                 <div>
                    <span className="text-primary font-bold tracking-[0.2em] mb-4 block uppercase text-sm">Empowering Industry</span>
                    <h2 className="text-3xl md:text-5xl font-black syne tracking-tighter mb-8 leading-[0.9]">
                      AgniThrust: <br />
                      <span className="text-2xl md:text-4xl text-white/40">Bio-Fuel Pioneers.</span>
                    </h2>
                    <p className="text-slate-400 text-xl font-medium leading-relaxed mb-8">
                       Leading the way in sustainable energy. We produce high-quality biomass pellets and bio coal for a greener tomorrow. Our mission is to reduce global carbon footprint one pellet at a time.
                    </p>
                    <div className="grid grid-cols-2 gap-8 mb-12">
                       <div className="flex items-center gap-3">
                          <Award className="text-primary" size={24} />
                          <span className="text-sm font-bold tracking-widest uppercase">Certified</span>
                       </div>
                       <div className="flex items-center gap-3">
                          <Globe className="text-primary" size={24} />
                          <span className="text-sm font-bold tracking-widest uppercase">Global Export</span>
                       </div>
                    </div>
                 </div>
                 <a href="/about" className="inline-block px-12 py-5 bg-white text-black hover:bg-primary hover:text-white rounded-2xl font-bold syne tracking-widest text-sm transition-all shadow-2xl">
                    LEARN MORE ABOUT US
                 </a>
               </div>
            </div>
         </section>
      </RevealSection>

      <RevealSection id="products_home">
        <Products onShowDetail={onShowDetail} />
      </RevealSection>
    </main>
  );
};

export default Home;
